import initPersonalDataModal from "./initPersonalDataModal";
import initPersonalDataAgreementModal from "./initPersonalDataAgreementModal";

function initPersonalDataButtonsForOpen() {
    const personalDataModalOpenButtons =
        document.querySelectorAll('[data-custom-open="personal-data"]');

    const personalDataAgreementModalOpenButtons =
        document.querySelectorAll('[data-custom-open="personal-data-agreement"]');

    personalDataModalOpenButtons.forEach((btn) => {
        if (btn.dataset.bound === "1") return;
        btn.dataset.bound = "1";

        btn.addEventListener("click", (evt) => {
            evt.preventDefault();
            initPersonalDataModal();
            MicroModal.show("personal-data");
        });
    });

    personalDataAgreementModalOpenButtons.forEach((btn) => {
        if (btn.dataset.bound === "1") return;
        btn.dataset.bound = "1";

        btn.addEventListener("click", (evt) => {
            evt.preventDefault();
            initPersonalDataAgreementModal();
            MicroModal.show("personal-data-agreement");
        });
    });
}

export default  initPersonalDataButtonsForOpen;
